
import { ArtworkResult } from '@/components/w2pFileUploader';
import { ProductPrintData } from '@midocean/webapps-shared-domain';
import Vue, { PropType } from 'vue';
import { useStore as useProductStore } from '@/stores/product';
import { mapState } from 'pinia';

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    masterProductSku: {
      type: String,
      default: '',
    },
    productDescription: {
      type: String,
      default: '',
    },
    uploadedFileData: {
      type: [] as PropType<ArtworkResult[]>,
      default: [],
    },
    fileUrl: {
      type: String,
      default: '',
    },
    selectedMethod: {
      type: String,
      required: true,
    },
    isDetailLost: {
      type: Boolean,
      default: false,
    },
    productPrintData: {
      type: Object as PropType<ProductPrintData>,
      required: false,
      default: {},
    },
    productVariantColor: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    ...mapState(useProductStore, ['data']),
  },

  methods: {
    positionImage(position: string | undefined) {
      const pp = this.data.productPrintPositions.find(
        (p) => p.name === position
      );

      return this.productPrintData.variants
        ?.find((v) => v.colour === this.productVariantColor)
        ?.images.find((i) => i.printPositionID === pp?.id)?.imageUrl as string;
    },
  },
});
